var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "product-rating",
      class:
        "product-rating--" +
        _vm.rating +
        " " +
        (_vm.colors ? "product-rating--colors" : ""),
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "80",
        height: "16",
        fill: "none",
        viewBox: "0 0 80 16"
      }
    },
    [
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.stroke,
          "stroke-width": ".5",
          d:
            "M8 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L8 12 4.1 14.07l.74-4.4-3.16-3.1 4.37-.64 1.96-4z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.stroke,
          "stroke-width": ".5",
          d:
            "M24 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L24 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.stroke,
          "stroke-width": ".5",
          d:
            "M40 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L40 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.stroke,
          "stroke-width": ".5",
          d:
            "M56 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L56 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"
        }
      }),
      _vm._v(" "),
      _c("path", {
        attrs: {
          fill: "none",
          stroke: _vm.stroke,
          "stroke-width": ".5",
          d:
            "M72 1.93l1.96 4 4.37.64-3.16 3.1.75 4.4L72 12l-3.91 2.07.74-4.4-3.16-3.1 4.37-.64 1.96-4z"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }